package fr.frux.shared.domain.model

/**
 * Domain status of a tree, decoupled from the transport enum le transport.
 *
 * UNAVAILABLE is a first-class state (tree reported as not harvestable:
 * private property, cut down, out of season…) and must always be mapped
 * and rendered explicitly — never treated as a fallback.
 */
enum class TreeStatus {
    FLOWERING,
    RIPE_READY,
    PICKED_CLEAN,
    UNAVAILABLE,

    /** Aucun état observé — arbre importé qu'aucun humain n'a encore regardé. */
    UNKNOWN
}
